module.exports = __webpack_public_path__ + "img/ring.ebf8f0c8.png";